import Lang from "../../common/lang/Lang";
import { EmailTemplateModel } from "../../model";

export const urls = {
  home: "/settings",
  list: "/settings/email-templates",
}

export const ListBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label: Lang.email_templates,
    url: "#"
  }
];

export const CreateBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label: Lang.email_templates,
    url: urls.list
  },
  {
    label: Lang.create,
    url: '#'
  }
];

export const EditBreadcrumb = [
  {
    label: Lang.settings,
    url: urls.home
  },
  {
    label: Lang.email_templates,
    url: urls.list
  },
  {
    label: Lang.edit,
    url: '#'
  }
];

export interface IState {
  id: number;
  template: EmailTemplateModel;
}